import { render, staticRenderFns } from "./HairExtensionSpecialist.vue?vue&type=template&id=67c6b17b"
import script from "./HairExtensionSpecialist.vue?vue&type=script&lang=js"
export * from "./HairExtensionSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports